import { render } from "./UserFullIcon.vue?vue&type=template&id=3cbb95f6"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/UserFullIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cbb95f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cbb95f6', __exports__)) {
    api.reload('3cbb95f6', __exports__)
  }
  
  module.hot.accept("./UserFullIcon.vue?vue&type=template&id=3cbb95f6", () => {
    api.rerender('3cbb95f6', render)
  })

}


export default __exports__